
import request from '@/utils/request'
import type { AxiosResponse } from 'axios'
export namespace FindGameByVendor {
    export interface Vendor {
        id: number;
        providerId: number;
        providerName: string;
        name: string;
        currencyCode: string[];
        code: string;
        categoryCode: string[];
        gameNum: number;
        createTime: string;
        logo: string
    }


    export interface Page {
        pageNo: number;
        pageSize: number;
        total: number;
    }

    export interface ListResponse<T> {
        list: T;
        total: number;
        totalPages: number;
        pageNo: number;
        pageSize: number;
    }
    export interface SearchParams {
        vendorId?: number;
        categoryCode?: string;
        gameType?: string;
        gameName?: string;
        tag?: number;
    }
    export interface Game {
        id: number;
        providerId: number;
        vendorId: number;
        vendorName: string;
        gameCode: string;
        gameName: string;
        categoryCode: string;
        imageSquare: string;
        imageLandscape: string;
        languageCode: string[];
        platformCode: string[];
        currencyCode: string[];
        updateTime: string;
        collect: boolean;
        columnId: number;
    }
    /**
     * 获取供应商列表
     * @param gameType 游戏类型
     * @returns 
     */
    export const getVendorList = (gameType?: string): Promise<AxiosResponse<Vendor[]>> => {
        return request.get<Vendor[]>('/platform/game-vendor/getVendors', {
            params: gameType ? { gameType } : {}
        })
    }

    // 獲取遊戲列表
    export const getAllGames = (params: Page & SearchParams): Promise<AxiosResponse<ListResponse<Game[]>>> => {
        return request.get("/platform/vendor-game/page", {
            params
        })
    }

    // 獲取收藏遊戲
    export const getFavoritosGames = (params: Page & SearchParams): Promise<AxiosResponse<ListResponse<Game[]>>> => {
        return request.get("/platform/vendor-game/collectPage", {
            params
        })
    }
    // 獲取最近遊戲
    export const getRecenteGames = (params: Page & SearchParams): Promise<AxiosResponse<ListResponse<Game[]>>> => {
        return request.get("/platform/vendor-game/getRecentGames", {
            params
        })
    }
    // 獲取熱門遊戲
    export const getPopularGames = (params: Page & SearchParams): Promise<AxiosResponse<ListResponse<Game[]>>> => {
        return request.get("/platform/vendor-game/page", {
            params: {
                ...params,
                tag: 1
            }
        })
    }
}
